const xsellUtils = require('od-modules/xsell/utils');

const DEFAULT_LANGUAGE = 'en';
const BRANDS = {
    ED: 'edreams',
    OP: 'opodo',
    TL: 'travel-link',
    GV: 'go-voyages',
};

function appContext() {
    const that = {};

    that.products = {
        CARS: 'cars',
        GT: 'groundtransportation',
        HOTELS: 'hotels',
        GYG: 'getyourguide',
        CP: 'parking',
    };

    Object.freeze(that.products);

    that.getBrand = function() {
        const brandId = Odigeo.SessionScope.brand;
        return Odigeo._.get(BRANDS, brandId, '');
    };

    that.getBrandId = function() {
        return Odigeo.SessionScope.brand;
    };

    that.getTopLevelDomain = function() {
        return window.location.hostname.split('.').pop();
    };

    that.getLocale = function() {
        return Odigeo.CrossSelling.locale;
    };

    that.getDate = function() {
        return new Date();
    };

    that.getLanguage = function() {
        return Odigeo._.get(Odigeo.CrossSelling, 'language', DEFAULT_LANGUAGE);
    };

    that.getCurrencyCode = function() {
        return Odigeo.Utils.Currency.currencyCode;
    };

    that.getFlow = function() {
        return Odigeo.SessionScope.flow;
    };

    that.isDesktopFlow = function() {
        return Odigeo.SessionScope.flow === 'desktop';
    };

    that.isMobileFlow = function() {
        return Odigeo.SessionScope.flow === 'mobile';
    };

    that.getFlowProduct = function() {
        if (this.getCurrentPage() === 'confirmation' && xsellUtils.isAccomodationPostBooking()) {
            return 'upsell';
        }

        return Odigeo.SessionScope.flowProduct;
    };

    that.isExpediaMarket = function() {
        return Odigeo.JCMS.crossSellHotelProvider.toLowerCase() === 'expedia';
    };

    that.getHotelProvider = function() {
        return Odigeo.JCMS.crossSellHotelProvider;
    };

    that.getCurrentPage = function() {
        switch (Odigeo.History.getPageNameFromFragment()) {
            case 'confirmation':
                return 'confirmation';
            case 'tripdetails':
                return 'tripdetails';
            case 'mytrips':
                return xsellUtils.isMyTripsHome() ? 'mytrips' : 'tripdetails';
            default:
                return '';
        }
    };

    return that;
}

module.exports = appContext();
